import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", showWord = true }) {
  return (
    <Link to="/" data-testid="brand-logo" className={`flex items-center gap-2 group ${className}`}>
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[hsl(var(--primary))] text-white shadow-sm">
        <span aria-hidden className="absolute -top-2 left-1/2 -translate-x-1/2 text-[10px] text-[hsl(var(--accent))]">~</span>
        <CoffeeCupIcon className="h-4 w-4" />
      </span>
      {showWord && (
        <span className="font-display text-lg font-semibold tracking-tight">
          Startup<span className="text-[hsl(var(--accent))]">Café</span>
        </span>
      )}
    </Link>
  );
}

function CoffeeCupIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M3 8h13a3 3 0 0 1 0 6h-1" />
      <path d="M3 8v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V8z" />
      <path d="M8 3c0 1 1 1 1 2s-1 1-1 2" />
      <path d="M12 3c0 1 1 1 1 2s-1 1-1 2" />
    </svg>
  );
}
